<template>
  <b-card class="bg-white rounded-xl px-2">
    <AddBannerPopup :isOpen="isPopupOpen" @close="togglePopup" />
    <div class="flex justify-between items-center">
      <div>
        <h2 class="text-2xl font-semibold">List of Campaigns</h2>
      </div>
      <div class="flex items-center gap-4">
        <!-- <el-switch
          class="text-primary"
          v-model="isAvailableForUser"
          @change="updatepageVisible"
          active-text="Enable"
          inactive-text="Disable"
        >
        </el-switch> -->
        <base-button
          outline
          class="px-6 py-1 mx-1"
          type="primary"
          @click="handleAdd"
        >
          <span class="btn-inner--text flex justify-between items-center"
            ><feather-icon icon="PlusIcon" class="cust-HW"></feather-icon>Add
            Campaign</span
          >
        </base-button>
      </div>
    </div>
    <BannerTable />
  </b-card>
</template>

<script>
import BannerTable from "./components/campaignTable.vue";
import AddBannerPopup from "./components/AddCampaignPopup.vue";
import { mapState } from "vuex";

export default {
  data() {
    return {
      isPopupOpen: false,
      isAvailableForUser: true,
    };
  },
  components: {
    BannerTable,
    AddBannerPopup,
  },
  methods: {
    async updatepageVisible() {
      let payload = {
        _id: this.getMasterCampaign._id,
        campaignPageVisible: this.isAvailableForUser,
      };

      let data = await this.$store.dispatch(
        "campaignPageBanner/updateMaster",
        payload
      );

      if (data.code == 200) {
        this.$store.dispatch("campaignPageBanner/getMaster");
      }
    },
    handleAdd() {
      this.$router.push({ name: "addCampaignHome" });
    },
    async togglePopup(val = false) {
      this.isPopupOpen = val;
    },
  },
  mounted() {
    this.isAvailableForUser = this.getMasterCampaign.campaignPageVisible;
  },
  computed: {
    ...mapState("campaignPageBanner", ["getMasterCampaign"]),
  },
};
</script>
<style>
.txt-color {
  color: #4f0a4b;
}
</style>
